import React, { FC } from 'react'
import SALink from 'components/SALink'
import {
  convertDefaultToLocaleCurrency,
  formatNumberToCurrencyCommas,
} from 'components/FormatPrice/helpers'
import { getUserPreferencesSelectedCurrency } from 'selectors/user/cookie'
import { useSelector } from 'react-redux'
import LocaleCurrencySymbol from 'components/FormatPrice/LocaleCurrencySymbol'
import styles from './Homepage.module.scss'
import useQA from 'hooks/useQA'
import { getSharedIsConstructorExperience } from 'selectors/shared/constructorExperience'

const PRICES = [
  {
    min: 0,
    max: 500,
  },
  {
    min: 500,
    max: 1000,
  },
  {
    min: 1000,
    max: 2000,
  },
  {
    min: 2000,
    max: 5000,
  },
]

const ShopByPrice: FC = () => {
  const { testId } = useQA()
  const selectedCurrency = useSelector(getUserPreferencesSelectedCurrency)
  const isConstructorExperience = useSelector(getSharedIsConstructorExperience)

  const priceFacetName = isConstructorExperience ? 'geo_prices' : 'price'

  return (
    <div className={styles.shopByPrice} {...testId('shop-by-price')}>
      <h4 className={styles.title}>Shop by Price</h4>
      <div className={styles.row}>
        {PRICES.map((price, index) => {
          const { min, max } = price
          const minPriceInCents =
            min > 0 ? convertDefaultToLocaleCurrency(min, selectedCurrency) : min
          const maxPriceInCents = convertDefaultToLocaleCurrency(max, selectedCurrency)

          return (
            <SALink
              href={`/all?${priceFacetName}=${min}-${max}`}
              key={index}
              className={styles.tile}
            >
              <p>
                {minPriceInCents > 0 ? (
                  <>
                    <LocaleCurrencySymbol selectedCurrency={selectedCurrency} />
                    {formatNumberToCurrencyCommas(minPriceInCents, selectedCurrency.locale)}-
                  </>
                ) : (
                  <>
                    UNDER <LocaleCurrencySymbol selectedCurrency={selectedCurrency} />
                  </>
                )}
                {minPriceInCents > 0 && (
                  <LocaleCurrencySymbol selectedCurrency={selectedCurrency} />
                )}
                {formatNumberToCurrencyCommas(maxPriceInCents, selectedCurrency.locale)}
              </p>
            </SALink>
          )
        })}
      </div>
    </div>
  )
}

export default ShopByPrice
